module.exports = __webpack_public_path__ + "img/insurance.21543391.svg";